// "Sunfaded Cardboard" — a thrift-store record bin: kraft cream, stamped rust ink, faded olive.
export const T = {
  bg: "#E8DCC0", surface: "#F5EFDD", card: "#F5EFDD", nav: "#DED0AE",
  navBorder: "#C9B98F", text: "#3B2E1E", muted: "#7A6A4E", accent: "#C1502E",
  accentAlt: "#D98A4A", border: "#C9B98F", value: "#8A9A5B",
  statBg: "#F5EFDD", inputBg: "#F5EFDD", btnBg: "linear-gradient(135deg,#A8402A,#C1502E)",
  btnGold: "linear-gradient(135deg,#6B7F45,#8A9A5B)", green: "#5C7A42",
  font: "'Palatino Linotype','Book Antiqua',Georgia,serif",
};
